module.exports = __webpack_public_path__ + "img/noyj.8a4a6f80.png";